<template>
	<div class="wpButton">
		<CustomButton :link="conditionalLink" :class="buttonClass" v-if="show">
			{{conditionalText}}
		</CustomButton>
	</div>
</template>

<script>
import CustomButton from '@/components/buttons/CustomButton'
import { mapState } from 'vuex'
const regex = /\[.*\]/
const strRegex = /[A-Za-z.:_\-/\s]+/gm

export default {
	name: "WPButton",
	props: ["text", "link", "view", "acf_fc_layout", "buttoncolour", "memberlevel"],
	components: {
		CustomButton
	},
	computed: {
		...mapState({
			memberLevel: state => state.auth.memberLevel,
			loggedIn: state => state.auth.loggedIn
		}),
		// Provides a conditional text based on member level.
		conditionalText() {
			if(this.text.match(regex)) {
				let matches = this.findMatches(this.text);
				switch (this.memberLevel) {
				case 'public':
					return matches[0];
				case 'silver':
					return matches[1];
				default:
					return matches[0];
				}
			}
			return this.text
		},
		conditionalLink() {
			if(this.link.match(regex)) {
				let matches = this.findMatches(this.link);
				// console.log(matches)
				switch (this.memberLevel) {
				case 'public':
					return matches[0];
				case 'silver':
					return matches[1];
				default:
					return matches[0];
				}
			}
			return this.link
		},
		buttonClass() {
			switch (this.buttoncolour) {
				case "#d9aa3c": 
					return "btn-upgrade"
				case "#3b3b3b":
					return "btn-platinum";
				default:
					return""
			}
		},
		show() {
			let showView = (this.view == "both" || (this.view == "logged_out" && !this.loggedIn) || (this.view == "logged_in" && this.loggedIn))
			let showmemberLevel = (this.memberlevel == "all" || (this.memberLevel == this.memberlevel))
			return showView && showmemberLevel
		}
	},
	methods: {
		findMatches(str) {
			let matches = Array.from(str.matchAll(strRegex))
			let realMatches = []
			for(let match of matches) {
				if(!(match [0] == "")) {
					realMatches.push(match[0])
				}
			}
			return realMatches
		}
	}
};
</script>

<style lang="scss" scoped>
.wpButton{
    text-align:center;
}


</style>
